import type { ReactNode } from 'react';

/**
 * PlaceholderPage — shared shell for Admin COG items that have been
 * added to the navigation surface but don't have a real implementation
 * yet (31 May 2026). Each "Coming soon" page declares its planned
 * phase + a 1-2 sentence description so an operator landing here knows
 * what to expect.
 *
 * Wrapped in AuthenticatedRoute upstream → inherits the AppHeader
 * (navbar + AI providers chip + COG + identity) automatically.
 */
export interface PlaceholderPageProps {
  title: string;
  /** "Phase 5d-3", "Phase 6+", etc — sets expectation about when this lands. */
  plannedPhase: string;
  /** 1-2 sentence description of what this page will eventually do. */
  intent: ReactNode;
  /** Optional bulleted feature list — what the page will cover when built. */
  features?: ReactNode[];
}

export function PlaceholderPage({ title, plannedPhase, intent, features }: PlaceholderPageProps) {
  return (
    <div className="portal-page portal-placeholder-page">
      <header className="portal-placeholder-header">
        <span className="portal-placeholder-badge">Coming soon · {plannedPhase}</span>
        <h1>{title}</h1>
        <p className="portal-placeholder-intent">{intent}</p>
      </header>
      {features && features.length > 0 && (
        <section className="portal-placeholder-features">
          <h2>Planned features</h2>
          <ul>
            {features.map((f, i) => (
              <li key={i}>{f}</li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
